
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {

  display: flex;

  flex-direction: row;

  fill: var(--neutral-white);

  color: var(--neutral-white)
}

outline-link {

  margin-right: 1rem;
}

outline-link svg {

  fill: var(--neutral-white)
}

outline-link svg {

  color: var(--neutral-white)
}

outline-link:hover svg, outline-link:focus svg {

  fill: var(--gray-professional-lighten-2)
}

outline-link:hover svg, outline-link:focus svg {

  color: var(--gray-professional-lighten-2)
}
`;